export default "__VITE_ASSET__02d62fce__"